import React from "react";
var __jsx = React.createElement;
import isEmpty from 'lodash/isEmpty';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';
import { useDependency } from 'libs/content/hooks';
import { Slideshow } from 'theme/icons';
import { Container, IconWrapper, Image, ImageWrapper, Label } from './SlideshowEmbedBlock.style';

var SlideshowEmbedBlock = function SlideshowEmbedBlock(_ref) {
  var _entityData$contentId, _ref2, _linkedContent$previe, _ref3, _linkedContent$label;

  var block = _ref.block,
      editorState = _ref.blockProps.editorState;

  var _useGetBlockData = useGetBlockData(editorState, block.getKey(), block.getEntityAt(0)),
      entityData = _useGetBlockData.entityData;

  var linkedContent = useDependency((_entityData$contentId = entityData.contentId) !== null && _entityData$contentId !== void 0 ? _entityData$contentId : '');
  return __jsx(Container, null, !isEmpty(entityData.contentId) && __jsx(React.Fragment, null, __jsx(ImageWrapper, null, __jsx(Image, {
    src: (_ref2 = (_linkedContent$previe = linkedContent === null || linkedContent === void 0 ? void 0 : linkedContent.previewImage) !== null && _linkedContent$previe !== void 0 ? _linkedContent$previe : entityData.previewImage) !== null && _ref2 !== void 0 ? _ref2 : ''
  }), __jsx(IconWrapper, null, __jsx(Slideshow, null))), __jsx(Label, null, (_ref3 = (_linkedContent$label = linkedContent === null || linkedContent === void 0 ? void 0 : linkedContent.label) !== null && _linkedContent$label !== void 0 ? _linkedContent$label : entityData.label) !== null && _ref3 !== void 0 ? _ref3 : '')));
};

export default SlideshowEmbedBlock;